import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["value", "disabled", "placeholder", "maxlength"]

import InputField from './InputField.vue';


export default /*#__PURE__*/_defineComponent({
  props: {
  modelValue: {
    type: [String, Number],
    required: true,
  },
  title: {
    type: String,
    default: null,
  },
  hint: {
    type: String,
    default: null,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  validationError: {
    type: String,
    default: null,
  },
  maxLength: {
    type: Number,
    default: 1000,
  },
  placeholder: {
    type: String,
    default: null,
  },
  status: {
    type: String,
  },
},
  emits: ['update:modelValue'],
  setup(__props, { emit }) {





function onUpdate(event: Event) {
  const element = event.target as HTMLInputElement;
  emit('update:modelValue', element.value);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(InputField, {
    title: __props.title,
    "validation-error": __props.validationError,
    hint: __props.hint
  }, {
    "title-badge": _withCtx(() => [
      (_ctx.$slots['title-badge'])
        ? _renderSlot(_ctx.$slots, "title-badge", { key: 0 })
        : _createCommentVNode("", true)
    ]),
    status: _withCtx(() => [
      _createTextVNode(_toDisplayString(__props.status), 1)
    ]),
    default: _withCtx(() => [
      _createElementVNode("textarea", {
        value: __props.modelValue,
        disabled: __props.disabled,
        onInput: onUpdate,
        placeholder: __props.placeholder,
        maxlength: __props.maxLength,
        class: _normalizeClass([
        'border-b w-full my-2 py-1',
        {
          'border-red-500 text-red-500': __props.validationError,
          'border-input-decoration': !__props.validationError,
        },
      ])
      }, null, 42, _hoisted_1)
    ]),
    _: 3
  }, 8, ["title", "validation-error", "hint"]))
}
}

})